"use client"

import { BeakerIcon, GiftIcon, LocationMarkerIcon } from "@heroicons/react/outline"
import { PhotographIcon, TagOutlineIcon } from "blx-icons"
import type { NavigationLinkItem } from "config/navigation/types/NavigationLinkItem"
import { BLXApplications } from "types"
import useMMBRoutes from "./useMMBRoutes"

const buildNavigationLinkItem = (
    navItem: Omit<NavigationLinkItem, "application" | "displayType" | "isDisabled">
): NavigationLinkItem => ({
    ...navItem,
    application: BLXApplications.Marketing,
    displayType: "link",
    isDisabled: false
})

interface MMBRouteNavigationLinkItems {
    mmbApplicationNavigationConfig: NavigationLinkItem[]
}

export const useMMBRouteNavigationLinkItems = (): MMBRouteNavigationLinkItems => {
    const { branding, currentMMBDashboard, locations, mmbMediaLibrary, products, staticRoutes } =
        useMMBRoutes()

    const { brandingStatic, locationsStatic, mmbMediaLibraryStatic, productsStatic } = staticRoutes

    const currentMMBDashboardLinkItem = buildNavigationLinkItem({
        icon: BeakerIcon,
        label: "Dashboard",
        path: currentMMBDashboard(),
        permittedRoles: ["admin", "owner", "staff"]
    })

    const brandingLinkItem = buildNavigationLinkItem({
        icon: TagOutlineIcon,
        label: "Branding",
        path: branding(),
        styleMatchingPath: brandingStatic,
        permittedRoles: ["admin", "owner", "staff"]
    })

    const productsLinkItem = buildNavigationLinkItem({
        icon: GiftIcon,
        label: "Products",
        path: products(),
        styleMatchingPath: productsStatic,
        permittedRoles: ["admin", "owner", "staff"]
    })

    const locationsLinkItem = buildNavigationLinkItem({
        icon: LocationMarkerIcon,
        label: "Locations",
        path: locations(),
        styleMatchingPath: locationsStatic,
        permittedRoles: ["admin", "owner", "staff"]
    })

    const mediaLibraryLinkItem = buildNavigationLinkItem({
        icon: PhotographIcon,
        label: "Media Library",
        path: mmbMediaLibrary(),
        styleMatchingPath: mmbMediaLibraryStatic,
        permittedRoles: ["admin", "owner", "staff"]
    })

    // Link Item Groups
    const mmbApplicationNavigationConfig = [
        currentMMBDashboardLinkItem,
        brandingLinkItem,
        productsLinkItem,
        locationsLinkItem,
        mediaLibraryLinkItem
    ]

    return {
        mmbApplicationNavigationConfig
    }
}
